import { useContext } from 'react'

import { WebSocketContext } from '~/shared/components/WebSocketProvider/context.ts'

export const useWebSocket = () => useContext(WebSocketContext)